import * as React from 'react';

export const EvShl: React.FunctionComponent = () => {
  return (
    <svg version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 368 368" width="512" height="512">
      <g>
        <g>
          <path
            d="M365,177.751l-160-128c-2.408-1.92-5.712-2.288-8.472-0.968c-2.76,1.336-4.528,4.144-4.528,7.216v72H16
			c-8.824,0-16,7.176-16,16v80c0,8.824,7.176,16,16,16h176v72c0,3.072,1.768,5.88,4.528,7.208c1.112,0.528,2.296,0.792,3.472,0.792
			c1.784,0,3.552-0.6,5-1.752l160-128c1.896-1.52,3-3.816,3-6.248S366.896,179.271,365,177.751z M208,295.351v-63.352
			c0-4.416-3.576-8-8-8H16l-0.016-80H16h184c4.424,0,8-3.584,8-8V72.647l139.192,111.352L208,295.351z"
          />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
  // return (
  //   <svg
  //     id="Layer_3"
  //     enableBackground="new 0 0 64 64"
  //     height="512"
  //     viewBox="0 0 64 64"
  //     width="512"
  //     xmlns="http://www.w3.org/2000/svg"
  //   >
  //     <g>
  //       <path d="m43 22c0-1.654 1.346-3 3-3s3 1.346 3 3v2c0 1.654-1.346 3-3 3s-3-1.346-3-3zm-26 0c0-1.654 1.346-3 3-3s3 1.346 3 3v2c0 1.654-1.346 3-3 3s-3-1.346-3-3zm8.632 11.203-4.548 10.396c-.194.444-.042.964.361 1.233l5.351 3.567-4.501 12.601h-2.908l3.562-10.684c.143-.428-.019-.898-.394-1.148l-6-4c-.278-.186-.629-.221-.938-.092-.308.127-.532.4-.598.728l-.929 4.643-8.91 7.128-1.78-2.375 7.2-5.4c.158-.118.277-.281.343-.467l6-17c.108-.306.061-.646-.126-.911-.188-.264-.492-.422-.817-.422-2.202 0-4.271.857-5.828 2.414l-4.172 4.172-1.586-1.586 4.071-4.071c1.889-1.889 4.4-2.929 7.071-2.929h7.328c1.031 0 1.946.495 2.511 1.358s.65 1.9.237 2.845zm2.151-2.203c-.125-.609-.363-1.199-.715-1.737-.06-.092-.131-.176-.197-.263h8.046c-.657.438-1.276.944-1.846 1.515l-.485.485zm23.849 2.203-4.548 10.396c-.194.444-.042.964.361 1.233l5.351 3.567-4.501 12.601h-2.908l3.562-10.684c.143-.428-.019-.898-.394-1.148l-6-4c-.277-.186-.63-.221-.938-.092-.308.127-.532.4-.598.728l-.929 4.643-8.91 7.128-1.78-2.375 7.2-5.4c.158-.118.277-.281.343-.467l6-17c.108-.306.061-.646-.126-.911-.188-.264-.492-.422-.817-.422-2.202 0-4.271.857-5.828 2.414l-4.172 4.172-1.586-1.586 4.071-4.071c1.889-1.889 4.4-2.929 7.071-2.929h7.328c1.031 0 1.946.495 2.511 1.358s.65 1.9.237 2.845zm9.368-2.203h-7.217c-.125-.609-.363-1.199-.715-1.737-.06-.092-.131-.176-.197-.263h8.129z" />
  //       <path d="m3 6h11c.552 0 1-.448 1-1v-.865l3.438 2.865-3.438 2.865v-.865c0-.552-.448-1-1-1h-11z" />
  //       <path d="m24 12h11c.552 0 1-.448 1-1v-.865l3.438 2.865-3.438 2.865v-.865c0-.552-.448-1-1-1h-11z" />
  //       <path d="m45 6h11c.552 0 1-.448 1-1v-.865l3.438 2.865-3.438 2.865v-.865c0-.552-.448-1-1-1h-11z" />
  //     </g>
  //   </svg>
  // );
};
